import React, { useState } from 'react';
import { Button, Stack, TextField } from '@mui/material';

import { MotionControls } from './MotionControls';
import { buildTextToVideo } from './buildRequests';
import type { VideoPanelProps } from './panelTypes';

/** Prompt → clip. The baseline op (A-F5). */
export const TextToVideoPanel: React.FC<VideoPanelProps> = ({
  controls,
  onControlsChange,
  onSubmit,
  isRendering,
}) => {
  const [prompt, setPrompt] = useState('');
  const canSubmit = prompt.trim().length > 0 && !isRendering;

  return (
    <Stack spacing={1.5}>
      <TextField
        label="Prompt"
        placeholder="Describe the motion you want…"
        value={prompt}
        onChange={e => setPrompt(e.target.value)}
        multiline
        minRows={2}
        size="small"
        fullWidth
      />
      <MotionControls kind="TextToVideo" value={controls} onChange={onControlsChange} />
      <Button
        variant="contained"
        disabled={!canSubmit}
        onClick={() => onSubmit('TextToVideo', buildTextToVideo(prompt, controls))}
      >
        {isRendering ? 'Rendering…' : 'Generate clip'}
      </Button>
    </Stack>
  );
};
